import React from "react";

export default function About() {
  return (
    <div name="About" className="bg-gradient-to-t from-black to-slate-800  w-full h-screen py-20">
      <div className=" text-white px-8 text-justify pt-10 pb-20 md:max-w-screen-lg md:mx-auto md:px-12 lg:px-0">
        <div>
          <p className="text-4xl border-b-2 w-[6.4rem] mb-16">About</p>
        </div>
        <p className="font-extralight text-slate-200">
          
        </p>
        <br></br>
        <p className="font-extralight text-slate-200">
        Exploring the world of technology and engineering with an open mind. Passionate about learning new things and putting them into practice.<br/>--<br/>Striving for excellence in all aspects of life. A 7th Sem B-Tech student at MNIT Jaipur, passionate about technology and the power of knowledge. Let's get to know each other!
        </p>
      </div>
    </div>
  );
}
